import MenuButton from "components/MenuButton";
import { Typography } from "@mui/material";

/**
 * 在庫メニュー画面
 */
export default function StockMenu() {
  return (
    <div className="menuRoot color3">
      <h2>
        <Typography fontSize={22}>メニュー</Typography>
      </h2>
      <div className="menuButtons">
        {/* <MenuButton
          path="/items"
          text="[商品一覧]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/item/:itemId/register"
          text="[商品追加]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/"
          text="[ホームに戻る]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/orders"
          text="[注文一覧]"
          iconOn=""
          iconOff=""
        /> */}
        <MenuButton path="/stock/main" text="[在庫一覧(商品部用]" iconOn="" iconOff="" />
        <MenuButton
          path="/stock/store"
          text="[在庫一覧(店舗用、店舗ログイン時)]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/stock/company"
          text="[在庫一覧(企業用、企業ログイン時)]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/stock/supplier"
          text="[在庫一覧(仕入先/外部倉庫様用、仕入先ログイン時)]"
          iconOn=""
          iconOff=""
        />
        <MenuButton
          path="/stock/supplier"
          text="[在庫一覧(仕入先/外部倉庫様用、倉庫ログイン時)]"
          iconOn=""
          iconOff=""
        />
        <div>※暫定版です</div>
      </div>
    </div>
  );
}
